import { Skeleton } from "@universe/ui/components/skeleton";

import {
  ACCOUNT_CARD_CLASSES,
  ACCOUNT_CARD_PADDING,
} from "@/components/accounts-summary";
import TransactionListSkeleton from "@/components/transaction-list-skeleton";

const ActionButtonSkeleton = ({ labelWidth }: { labelWidth: string }) => (
  <div className="flex flex-col items-center gap-2">
    <Skeleton className="w-10 h-10 lg:w-12 lg:h-12 rounded-full" />
    <Skeleton className={`h-4 ${labelWidth}`} />
  </div>
);

export const TotalBalanceSkeleton = () => {
  return (
    <div className="rounded-lg w-full flex flex-col justify-between pb-2 gap-3">
      <div className="flex flex-row items-center gap-3 lg:gap-4 justify-center">
        <div className="flex flex-col items-center gap-1">
          <div className="flex min-h-7 items-center justify-center">
            <Skeleton className="h-5 md:h-6 w-50 lg:w-56" />
          </div>
          <div className="flex h-11 md:h-12 items-center justify-center py-1">
            <Skeleton className="h-9 md:h-10 w-48 lg:w-64" />
          </div>
        </div>
      </div>

      <div className="flex flex-row gap-10 justify-center">
        <ActionButtonSkeleton labelWidth="w-12" />
        <ActionButtonSkeleton labelWidth="w-16" />
        <ActionButtonSkeleton labelWidth="w-14" />
      </div>
    </div>
  );
};

export const AccountsSummarySkeleton = () => {
  const opacities = ["opacity-100", "opacity-75", "opacity-50", "opacity-20"];

  return (
    <div className="flex gap-4 overflow-x-hidden pt-2 pb-4">
      {[1, 2, 3, 4].map((index) => (
        <div
          key={index}
          className={`bg-brand-primary/6 border border-brand-primary/40 rounded-lg flex flex-col items-center justify-between ${ACCOUNT_CARD_PADDING} ${ACCOUNT_CARD_CLASSES} flex-shrink-0 overflow-hidden transition-opacity ${opacities[index - 1]}`}
          style={{
            boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.2)",
          }}
        >
          <div className="flex items-center justify-center pt-0.5 mb-2">
            <Skeleton className="h-[36px] w-[36px] lg:h-[44px] lg:w-[44px] rounded-full" />
          </div>

          <div className="flex flex-col items-center w-full pb-1 gap-2">
            <Skeleton className="h-4 lg:h-[22px] w-24 lg:w-32" />
            <Skeleton className="h-3 lg:h-4 w-20 lg:w-24" />
          </div>
        </div>
      ))}
    </div>
  );
};

const DashboardSkeleton = () => {
  return (
    <div className="flex flex-col gap-3">
      <TotalBalanceSkeleton />

      <div className="flex flex-col">
        <div className="flex justify-between items-center py-4">
          <Skeleton className="h-6 md:h-7 w-30" />
          <Skeleton className="h-5 md:h-6 w-20" />
        </div>

        <AccountsSummarySkeleton />
      </div>

      {/* Divider matching ActivityTabs default (no pending items) */}
      <hr className="hidden md:block md:my-1 opacity-65" />

      <TransactionListSkeleton skeletonCount={4} minHeight="250px" />
    </div>
  );
};

export default DashboardSkeleton;
